import '../../sass/plugins/our_method_carousel.scss';
import { SMALL_SCREEN } from '../consts';

$(() => {
  const ourMethodCarousels = $('.our-method-carousel');

  const initializeOurMethodCarousels = (element) => {
    const sliderSteps = $(element).find('.our-method-carousel__steps');
    const sliderStep = $(element).find('.our-method-carousel__content');

    const nextArrow = $(element).find('.next');
    const prevArrow = $(element).find('.prev');

    const prevButton = $(element).find('.prev-buttons .button-wrapper');
    const nextButton = $(element).find('.next-buttons .button-wrapper');

    const stepsCount = $(element).find('.step').length;
    let slidesToShow = 3;
    if (stepsCount < 3) {
      slidesToShow = stepsCount - 1;
    }
    if (stepsCount <= 1) {
      slidesToShow = 1;
    }

    sliderSteps.slick({
      infinite: false,
      arrows: true,
      slidesToShow,
      slidesToScroll: 1,
      variableWidth: true,
      nextArrow,
      prevArrow,
      centerMode: true,
      asNavFor: '.our-method-carousel__content',
    });

    sliderStep.slick({
      infinite: false,
      slidesToShow: 1,
      nextArrow: nextButton,
      prevArrow: prevButton,
      fade: true,
      swipe: false,
      mobileFirst: true,
      asNavFor: '.our-method-carousel__steps',
    });

    $(window).on('resize', () => {
      sliderSteps.slick('setPosition');
      sliderSteps.slick('refresh');
    });
  };

  ourMethodCarousels.each((_, element) =>
    initializeOurMethodCarousels(element)
  );
});
